/* MT — interactividad propia (vanilla, sin librerías) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCifras() {
    var nums = document.querySelectorAll('[data-mt-contar]:not([data-mt-hecho])');
    if (!nums.length) return;
    function animar(el) {
      el.setAttribute('data-mt-hecho', '1');
      var fin = parseFloat(el.getAttribute('data-mt-contar')) || 0;
      if (reducido) { el.textContent = fin; return; }
      var dur = 1600, t0 = null;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(fin * e);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(animar); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) { if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    nums.forEach(function (el) { io.observe(el); });
  }

  function initGaleria() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (gal) {
      if (gal.dataset.mtListo) return;
      gal.dataset.mtListo = '1';
      var principal = gal.querySelector('[data-mt-principal]');
      if (!principal) return;
      gal.querySelectorAll('[data-mt-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          gal.querySelectorAll('[data-mt-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = btn.getAttribute('data-src');
            principal.srcset = btn.getAttribute('data-srcset') || '';
            principal.alt = btn.getAttribute('data-alt') || '';
            principal.style.opacity = '1';
          }, 180);
        });
      });
    });
  }

  function initCantidad() {
    document.querySelectorAll('[data-mt-cantidad]').forEach(function (c) {
      if (c.dataset.mtListo) return;
      c.dataset.mtListo = '1';
      var input = c.querySelector('input');
      c.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = b.getAttribute('data-accion') === 'mas' ? v + 1 : Math.max(1, v - 1);
          input.value = v;
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
      if (root.dataset.mtListo) return;
      root.dataset.mtListo = '1';
      var json = root.querySelector('[data-mt-variantes]');
      if (!json) return;
      var variantes = JSON.parse(json.textContent);
      var inputId = root.querySelector('input[name="id"]');
      var precio = root.querySelector('[data-mt-precio]');
      var tachado = root.querySelector('[data-mt-tachado]');
      var boton = root.querySelector('[data-mt-boton]');
      var formato = root.getAttribute('data-mt-moneda') || '${{amount_no_decimals_with_comma_separator}}';
      var txtAgotado = root.getAttribute('data-mt-agotado') || 'Agotado';
      var txtBoton = boton ? boton.querySelector('span').textContent : '';
      function dinero(c) {
        var sep = /comma_separator|period_and_comma/.test(formato) ? '.' : ',';
        var n = Math.round(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        return formato.replace(/\{\{\s*\w+\s*\}\}/, n);
      }
      root.addEventListener('change', function (e) {
        if (!e.target.closest('[data-mt-opciones]')) return;
        var sel = [];
        root.querySelectorAll('[data-mt-opciones] fieldset').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
        });
        var v = variantes.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) return;
        inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (tachado) {
          tachado.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : '';
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? txtBoton : txtAgotado;
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  // Packs por cantidad: la tarjeta elegida fija la cantidad y muestra el precio del pack
  function initPacksCantidad() {
    document.querySelectorAll('[data-mt-packs-cantidad]').forEach(function (packs) {
      if (packs.dataset.mtListo) return;
      packs.dataset.mtListo = '1';
      var form = packs.closest('form');
      var root = packs.closest('[data-mt-producto]') || document;
      var cantidad = form && form.querySelector('input[name="quantity"]');
      var precio = root.querySelector('[data-mt-precio]');
      var tachado = root.querySelector('[data-mt-tachado]');
      packs.addEventListener('change', function (e) {
        var r = e.target;
        if (r.name !== 'mt-pack-cantidad') return;
        if (cantidad) cantidad.value = r.value;
        if (precio) precio.textContent = r.getAttribute('data-precio');
        if (tachado) tachado.textContent = r.getAttribute('data-tachado') || '';
      });
    });
  }

  function initBarraFija() {
    var barra = document.querySelector('[data-mt-barra]');
    var objetivo = document.querySelector('[data-mt-boton]') || document.querySelector('[data-mt-objetivo]');
    if (!barra || !objetivo || barra.dataset.mtListo) return;
    barra.dataset.mtListo = '1';
    // Visible cuando el botón principal ya quedó por encima de la pantalla
    var pendiente = false;
    function revisar() {
      pendiente = false;
      barra.classList.toggle('is-visible', objetivo.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(revisar); }
    }, { passive: true });
    revisar();
    var btn = barra.querySelector('button');
    if (btn && objetivo.hasAttribute('data-mt-boton')) btn.addEventListener('click', function () { objetivo.click(); });
  }

  function initComparadores() {
    document.querySelectorAll('[data-mt-comparador]').forEach(function (c) {
      if (c.dataset.mtListo) return;
      c.dataset.mtListo = '1';
      var rango = c.querySelector('.mt-ad__rango');
      if (!rango) return;
      var tocado = false;
      function poner(v) { c.style.setProperty('--mt-pos', v + '%'); rango.value = v; }
      rango.addEventListener('input', function () {
        tocado = true; c.classList.add('is-usado');
        c.style.setProperty('--mt-pos', rango.value + '%');
      });
      // Pequeña animación al aparecer para mostrar que se puede deslizar
      if (reducido || !('IntersectionObserver' in window)) return;
      var inicio = parseFloat(rango.value) || 50;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          var pasos = [inicio, inicio - 18, inicio + 18, inicio], i = 0, t0 = null, dur = 650;
          setTimeout(function () {
            function anim(t) {
              if (tocado || i >= pasos.length - 1) return;
              if (!t0) t0 = t;
              var p = Math.min((t - t0) / dur, 1), e2 = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
              poner(Math.round((pasos[i] + (pasos[i + 1] - pasos[i]) * e2) * 10) / 10);
              if (p >= 1) { i++; t0 = null; }
              requestAnimationFrame(anim);
            }
            requestAnimationFrame(anim);
          }, 500);
        });
      }, { threshold: 0.5 });
      io.observe(c);
    });
  }

  function init() {
    initComparadores(); initPacksCantidad();
    initReveals(); initCifras(); initGaleria(); initCantidad(); initVariantes(); initBarraFija();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
